import { render } from "./MenuLabel.vue?vue&type=template&id=dd318120&lang=pug"
import script from "./MenuLabel.vue?vue&type=script&lang=js"
export * from "./MenuLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__